// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/section/section.scss
// module id = 529
// module chunks = 0